import React from 'react';

import { getCP3Env } from '../../../../CP3Config';

/**
 * Higher Order Function that will return a HOC connecting the given Component
 * to the Provider also given, using the Consumer.
 *
 * NOTE: When this function was originally developed, the map props were written to take
 * precendence over the given Component props. This is troublesome for testing but
 * changing this behavior could break other areas of the app, so for now we are
 * taking advantage of the NODE_ENV. When it is test, the component props will
 * overwrite the mapped props, allowing to directly pass mock props to components
 * connected to the Providers.
 */

const withContext = (Consumer, Provider = null) => (
	mapContextToProps,
	options = {}
) => Component => {
	const ContextComponent = props => {
		const testEnv = getCP3Env('NODE_ENV') === 'test';

		const children = (
			<Consumer>
				{contexValue => (
					<Component
						{...props}
						{...mapContextToProps(contexValue, props)}
						{...(testEnv ? props : {})}
					/>
				)}
			</Consumer>
		);

		const mountProvider = options.mountProvider && Provider;

		return mountProvider ? <Provider>{children}</Provider> : children;
	};

	ContextComponent.displayName =
		options.displayName ||
		`ContextComponent(${Component.displayName ||
			Component.name ||
			'Component'})`;

	return ContextComponent;
};

export default withContext;
